import { render, staticRenderFns } from "./UsuariosAseguradoras.vue?vue&type=template&id=06f7fafa&scoped=true"
import script from "./UsuariosAseguradoras.vue?vue&type=script&lang=js"
export * from "./UsuariosAseguradoras.vue?vue&type=script&lang=js"
import style0 from "./UsuariosAseguradoras.vue?vue&type=style&index=0&id=06f7fafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f7fafa",
  null
  
)

export default component.exports